// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "owa." + {1070: "calendar",1545: "vendors",20644: "options",24014: "styles",25534: "stickynotes",55596: "confetti",65719: "today",74589: "shared",74983: "mail",}[chunkId] + ".m." + {1070: "e09dfa86",1545: "b1ab1c64",20644: "e40d2fa0",24014: "5b9adf28",25534: "b5bbcd5f",55596: "9bee98dc",65719: "dc9b603e",74589: "f0255010",74983: "e759931b",}[chunkId] + ".css"
}